var _style, _line, _path, _polyline, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaiter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4,
    y1: 16,
    x2: 29,
    y2: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,31l1.9-1.4c3.3-2.4,5.7-5.7,6.8-9.6l0,0h-2.6l0,0.1c-1.1,1.9-2.7,3.6-4.5,4.9l0,0c-0.6,0.4-1.5-0.1-1.4-1 l0.1-1.7c-0.2-1.3-1.2-2.2-2.3-2.2h-0.6v1c0,3.2-0.9,6.4-2.6,9l0,0"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "27,16 25,20 8,20 6,16 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,15.5C6,9.7,10.7,5,16.5,5S27,9.7,27,15.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16.5,
    cy: 3.5,
    r: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiter);
export default __webpack_public_path__ + "static/media/waiter.f0ff63c76582a854555896a687d8ef7d.svg";
export { ForwardRef as ReactComponent };